// @ts-nocheck
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { URL } from "../../service/Service";
import AuthShell from "../../components/auth/AuthShell";
import { ArrowLeftIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "../../i18n/LanguageContext";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [userEmail, setUserEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
    try {
      await axios.post(`${URL}/api/resetpassword`, {
        userEmail: userEmail,
      });
      setLoading(false); // Stop loading after the request is successful
      navigate("/login");
    } catch (error) {
      setLoading(false); // Stop loading if there's an error
      setError("Ocorreu um erro ao processar sua solicitação.");
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <AuthShell
      eyebrow={t('reset.eyebrow')}
      title={t('reset.title')}
      description={t('reset.description')}
    >
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="ui-label">
                Email
              </label>
              <div className="relative">
                <EnvelopeIcon className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  className="ui-input pl-12"
                  placeholder={t('reset.emailPlaceholder')}
                />
              </div>
            </div>

            <div className="grid gap-3 sm:grid-cols-[1fr_auto]">
              <button
                type="submit"
                disabled={loading}
                className="ui-button-primary w-full"
              >
                {loading ? (
                  <div className="flex items-center">
                    <svg
                    className="mr-2 h-5 w-5 animate-spin text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    {t('reset.sending')}
                  </div>
                ) : (
                  t('reset.send')
                )}
              </button>
              <button
                type="button"
                onClick={handleBackToLogin}
                className="ui-button-secondary"
              >
                <ArrowLeftIcon className="h-4 w-4" />
                {t('reset.back')}
              </button>
            </div>
            {error && <div className="ui-alert-error" role="alert">{error}</div>}
          </form>
    </AuthShell>
  );
}
